package component

import b2d.userdata.*
import com.github.quillraven.fleks.*
import com.soywiz.korge.view.*
import org.jbox2d.dynamics.*

class TrapComponent(
//    val view: SolidRect,
    val userData: TrapUserData,
    val body: Body
) : Component<TrapComponent> {

    var timeAccumulator = 0f

    override fun type() = TrapComponent

    companion object : ComponentType<TrapComponent>()
}
